// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/LabelCheckboxGroup.css */

.check-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem; /* 上下・左右の隙間 */
  margin: 0.25rem 0;
}

.check-item {
  display: flex;
  align-items: center;
  min-width: 150px; /* ラベルが長いときも適度に幅を確保 */
  margin-bottom: 0.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/LabelCheckboxGroup.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,aAAa;EACb,eAAe;EACf,gBAAgB,EAAE,aAAa;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB,EAAE,qBAAqB;EACvC,sBAAsB;AACxB","sourcesContent":["/* src/components/LabelCheckboxGroup.css */\n\n.check-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 1rem; /* 上下・左右の隙間 */\n  margin: 0.25rem 0;\n}\n\n.check-item {\n  display: flex;\n  align-items: center;\n  min-width: 150px; /* ラベルが長いときも適度に幅を確保 */\n  margin-bottom: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
